'use client';

import { usePersistentScrid } from '@packages/shared/src/hooks/usePersistentScrid/usePersistentScrid';

export const PersistentScrid = () => {
  usePersistentScrid();

  return null;
};
